module.exports = __webpack_public_path__ + "static/media/image_up_arrow_selection.d8bf1156.png";